<q-page class="flex flex-center bg-primary"><img class="spinner" src="~/assets/favicon.svg"></q-page>